import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { Zoom } from "@mui/material";
import { normalizeQuestion } from "../../../utils/questionNormalizer.js";

function TrueOrFalseQuestionsRenderer({
  handleTrueOrFalseQuestionsEdit,
  handleTrueOrFalseQuestionDelete,
  handleTrueOrFalseQuestionChange,
  handleSource,
  question,
  user,
  index,
}) {

  const normalizedQuestion = normalizeQuestion(question, "truefalse");

  return (
    <>
      {/* {trueFalseQuestions.map((trueFalseQuestion, index) => ( */}
      <div
        key={index}
        className="mb-4  border-slate-100 hover:border-[#f4833d] border-2 hover:border-dotted rounded question-answer-container p-4"
      >
        {/* Question goes here */}
        <div className="flex place-content-between">
          <div className="flex">
            <span>{index + 1}. </span>{" "}
            {question.editing ? (
              // <input
              //   type="text"
              //   ref={(inputRef) => inputRef && inputRef.focus()}
              //   className="w-[65vw]"
              //   value={trueFalseQuestion.question}
              //   onChange={(e) =>
              //     handleTrueOrFalseQuestionChange(index, e.target.value)
              //   }
              //   onBlur={() => handleTrueOrFalseQuestionsEdit(index)} // Exit editing mode on blur
              // />

              <div
                contentEditable="true"
                id={`question-${normalizedQuestion.index}`}
                className="wh-question-editable "
                onBlur={(e) => {
                  handleTrueOrFalseQuestionChange(
                    normalizedQuestion.index,
                    e.target.textContent
                  );
                  handleTrueOrFalseQuestionsEdit(normalizedQuestion.index);
                }}
                dangerouslySetInnerHTML={{
                  __html: normalizedQuestion.question,
                }}
              />
            ) : (
              <span
                onClick={() => handleTrueOrFalseQuestionsEdit(normalizedQuestion.index)}
                className="cursor-pointer"
                dangerouslySetInnerHTML={{
                  __html: normalizedQuestion.question,
                }}
              />
            )}
          </div>


          <div className="flex edit-delete-icons">
             {/* Source Icon */}
            {/* {!user.isGPT  &&
             <Tooltip
                title="Source"
                arrow
                placement="top"
                TransitionComponent={Zoom}
                TransitionProps={{ timeout: 300 }}
              >
                <button
                  onClick={() => handleSource(normalizedQuestion.originalSentence)}
                  className="text-[#f4843e] mr-2"
                >
                  <i className="fa-solid fa-book"></i>{" "}
                </button>
              </Tooltip>} */}

            {/* Edit Icon */}
            <Tooltip
              title="Edit"
              arrow
              placement="top"
              TransitionComponent={Zoom}
              TransitionProps={{ timeout: 300 }}
            >
              <button
                onClick={() => handleTrueOrFalseQuestionsEdit(normalizedQuestion.index)}
                className="text-indigo-500 mr-2"
              >
                <i className="fa-solid fa-pen-to-square"></i>{" "}
              </button>
            </Tooltip>

            {/* Delete Icon */}
            <Tooltip
              title="Delete"
              arrow
              placement="top"
              TransitionComponent={Zoom}
              TransitionProps={{ timeout: 300 }}
            >
              <button
                onClick={() => handleTrueOrFalseQuestionDelete(normalizedQuestion.index)}
                className="text-red-500"
              >
                <i className="fa-solid fa-trash"></i>{" "}
              </button>
            </Tooltip>
          </div>
        </div>

        {/* True or False Option */}
        <div className=" p-2 rounded ">
          <p
            className={`w-2/3 p-2 mb-1 rounded ${
              normalizedQuestion.answer === "true" || "True" === normalizedQuestion.answer ? "bg-[#c0f0e2]" : "bg-[#fdecf6]"
            }`}
          >
            True {normalizedQuestion.true_option}
          </p>
          <p
            className={`w-2/3 p-2 mb-1 rounded ${
              normalizedQuestion.answer === "false" || "False" === normalizedQuestion.answer ? "bg-[#c0f0e2]" : "bg-[#fdecf6]"
            }`}
          >
            False {normalizedQuestion.false_option}
          </p>
        </div>

        {/* Correct Answer */}
        <p>
          <strong>Answer:</strong> {normalizedQuestion.answer}
        </p>
      </div>
      {/* ))} */}
    </>
  );
}

export default TrueOrFalseQuestionsRenderer;
